import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import "../Slide/SlideDeleteValidator.scss";
import "../../css/Popup.scss";
 
const ConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  title = "ARE YOU SURE GO BACK TO THE DASHBOARD",
  message = "If you go back to the dashboard, you will exit the flow and return to the dashboard.",
  confirmText = "YES",
  cancelText = "NO",
}) => {
  const handleConfirm = () => {
    onConfirm();
    onHide();
  };
 
  const handleCancel = () => {
    onHide();
  };
 
  return (
    <div className="deletePromptParent">
      <Dialog
        open={show}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="deletePrompt confirmation"
        sx={{
          backdropFilter: "blur(2.4px)",
        }}
      >
        <DialogContent style={{overflowY: "initial", width: "380px", height:"160px"}}>
          <DialogContentText
            id="alert-dialog-description"
            className="discription"
            
          >
            <div className="popup-head">{title}</div>
            <div className="popup-separator"></div>
            <div className="popup-message"> {message} </div>
          </DialogContentText>
        </DialogContent>
        <div className="popupFooter">
          {/* <div className="popupFooterSeparator"></div> */}
          <Button
            className="btn popupFooterGrayedButton"
            type="button"
            onClick={handleCancel}
          >
            {cancelText}
          </Button>
          <Button
            className="btn popupFooterActiveButton"
            type="button"
            onClick={handleConfirm}
          >
            {confirmText}
          </Button>
        </div>
      </Dialog>
    </div>
  );
};
 
export default ConfirmationModal;